module.exports = __webpack_public_path__ + "img/4.526108f2.jpg";